<template>
	<div class="block-title">
		<div class="title-tab">
			<i class="iconfont" :class="iconf"></i>
			<h2 @click="jump" :class="{jump: title === '平台消息'}">{{title}}</h2>
		</div>
	</div>
</template>

<script>
export default {
	name: 'blockTitle',
	props: ['title','iconf'],
	methods: {
		jump () {
			if (this.title === '平台消息') {
				window.open('http://help.web724.cn/article/ptxx.html')
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.block-title {
	position: relative;
	margin-bottom: 16px;
	.color-block {
		width: 6px;
		height: 17px;
		background-color: $colorA;
		border-left: 1px solid #eee;
	}
	.title-tab{
		max-width: 70%;
		padding-left: 20px;
		height: 60px;
		display: flex;
		align-items: center;
		i{
			width:20px;
			font-size: 20px;
			color:$colorD;
		}
		h2 {
			height: 60px;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 2px;
			line-height: 60px;
			color: #373D45;
			padding-left: 10px;
			&.jump {
				cursor: pointer;
			}
		}
	}
}
</style>
